module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-DemiLight-Hestia.378aad9.woff";